/**
 * ListPropertyButton Component (Client Island)
 *
 * Diamond Architecture: Client Component for auth-gated navigation.
 * - Visible in navbar (prominent placement matching Rails)
 * - Opens auth modal if user is not signed in
 * - Navigates to /account/listings/new if signed in
 *
 * Matches Rails: ButtonLinkComponent with data-requires-auth
 *
 * A REAL ANCHOR in the server HTML (LET-83). It used to be an `AppButton
 * onClick` that called `requireAuth()` then `router.push(…)`, so on every
 * server-rendered page the navbar's most prominent call to action was a
 * control whose destination existed only in JS: dead before hydration, dead
 * without JS, no middle-click. Now the anchor points at the real destination
 * and the seam's `gate` is the enhancement — with JS a signed-out click opens
 * the modal in place; without it the browser navigates and the auth
 * middleware redirects to the home page carrying the auth-modal params, so a
 * reader with no JS is never stranded. The same button styling applies through
 * `asChild`, and `Button` deliberately does not hydration-gate an `asChild`
 * anchor: navigation works pre-hydration.
 */
import { EnhancedLink } from '@/shared/i18n/routing';
import { useTranslations } from '@/shared/i18n/useTranslations';
import { useAuthGate } from '@/shared/providers/AuthProvider';
import { routes } from '@letsgethome/routes';
import { AppButton } from '@letsgethome/ui/app-button';

export function ListPropertyButton() {
  const t = useTranslations('nav.account');
  const { requireAuth } = useAuthGate();

  return (
    <AppButton variant="ghost" size="sm" asChild className="whitespace-nowrap">
      {/* `rel="nofollow"`: a real destination, but an auth-gated one a crawler
          should not be invited into (robots.txt Disallows `/account` anyway;
          this is the per-link statement of it). */}
      <EnhancedLink href={routes.account.listings.new()} gate={requireAuth} rel="nofollow">
        {t('listProperty')}
      </EnhancedLink>
    </AppButton>
  );
}
